import React from "react";
// import "./Register.css"
import "./Account.css"
import Fire from "../config/Fire";
import Colors from "../utils/Colors";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import { Link } from 'react-router-dom'
import { withMyDataContext } from "../context/DataProvider";

import PencilIcon from "mdi-react/PencilIcon"
import LockIcon from "mdi-react/LockIcon"
import EmailIcon from "mdi-react/EmailIcon"
import AccountIcon from "mdi-react/AccountBoxIcon"
import FileDocumentIcon from "mdi-react/FileDocumentIcon"
import ChevronRightIcon from "mdi-react/ChevronRightIcon"
import DialogModal from "../utils/Utilities/DialogModal";
import Aux from "../utils/AuxFunctions";

class Settings extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            deleteDialog: false,
            logoutDialog: false,
            deleting: false,
            loggingOut: false,
            loginDialog: false,
        }
    }



    deleteAccount = async () => {
        if (this.state.deleting)
            return
        try {
            this.setState({ deleting: true })
            await Fire.shared.deleteAccount().then((didDelete) => {
                if (didDelete) {
                    this.props.myDataProvider.signOut();
                    this.setState({ deleting: false })
                    this.props.history.push('/')

                }
                this.setState({ deleting: false })

            })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    logoutAccount = async () => {
        if (this.state.loggingOut)
            return
        try {
            this.setState({ loggingOut: true })
            await this.props.myDataProvider.signOut();
            this.setState({ loggingOut: false })

        } catch (error) {
            this.setState({ loggingOut: false })
            Aux.handleError(error)
        }
    }

    goToDelete = () => {
        try {
            this.props.history.push("/account/delete")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    render() {
        return (
            <div style={{ width: "100%" }}>
                <DialogModal active={this.state.deleteDialog} onConfirm={this.deleteAccount} onClose={() => this.setState({ deleteDialog: false })} text="Are you sure you want to Delete your account?" />
                <DialogModal active={this.state.logoutDialog} onConfirm={this.logoutAccount} onClose={() => this.setState({ logoutDialog: false })} text="Are you sure you want to Logout?" />
                <section className="container">
                    <div style={{ margin: "20px 0px" }}>
                        <div style={{ marginBottom: 10 }}>
                            <h2 style={{ marginBottom: 20 }}>Settings</h2>
                        </div>
                        {this.props.myDataProvider.user ?
                            <div>
                                <div>
                                    <span>Account</span>
                                    <Link className="cat-single-item-menu" style={{ color: Colors.darkText }} to={"/account/edit"} >
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {/* <img src={item.image} style={{ width: 30, marginRight: 10, height: 30, objectFit: "contain" }}></img> */}
                                            <PencilIcon style={{ marginRight: 10 }}></PencilIcon>
                                    Edit Profile
                                </div>

                                        <ChevronRightIcon></ChevronRightIcon>
                                    </Link>

                                    <Link className="cat-single-item-menu" style={{ color: Colors.darkText }} to={"/account/password"} >
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {/* <img src={item.image} style={{ width: 30, marginRight: 10, height: 30, objectFit: "contain" }}></img> */}
                                            <LockIcon style={{ marginRight: 10 }}></LockIcon>
                                    Change Password
                                </div>

                                        <ChevronRightIcon></ChevronRightIcon>
                                    </Link>

                                    <Link className="cat-single-item-menu" style={{ color: Colors.darkText }} to={"/account/email"} >
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {/* <img src={item.image} style={{ width: 30, marginRight: 10, height: 30, objectFit: "contain" }}></img> */}
                                            <EmailIcon style={{ marginRight: 10 }}></EmailIcon>
                                    Change Email
                                </div>

                                        <ChevronRightIcon></ChevronRightIcon>
                                    </Link>
                                    <Link className="cat-single-item-menu" style={{ color: Colors.darkText }} to={"/account/refer"} >
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {/* <img src={item.image} style={{ width: 30, marginRight: 10, height: 30, objectFit: "contain" }}></img> */}
                                            <AccountIcon style={{ marginRight: 10 }}></AccountIcon>
                                    Referrals and Promo Codes
                                </div>

                                        <ChevronRightIcon></ChevronRightIcon>
                                    </Link>
                                </div>

                            </div>
                            :
                            null
                        }
                        <div>
                            <div style={{margin:"5px 0"}}>
                            <span>App</span>
                            </div>
                            <Link className="cat-single-item-menu" style={{ color: Colors.darkText }} to={"/contact"} >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {/* <img src={item.image} style={{ width: 30, marginRight: 10, height: 30, objectFit: "contain" }}></img> */}
                                    <AccountIcon style={{ marginRight: 10 }}></AccountIcon>
                                    Contact Us
                                </div>
                                <ChevronRightIcon></ChevronRightIcon>
                            </Link>
                            <Link className="cat-single-item-menu" style={{ color: Colors.darkText }} to={"/privacy"} >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {/* <img src={item.image} style={{ width: 30, marginRight: 10, height: 30, objectFit: "contain" }}></img> */}
                                    <FileDocumentIcon style={{ marginRight: 10 }}></FileDocumentIcon>
                                    Privacy Policy
                                </div>

                                <ChevronRightIcon></ChevronRightIcon>
                            </Link>
                        </div>
                        {this.props.myDataProvider.user ?
                            <div>
                                <span>Logout</span>
                                <div style={{ display: "flex", alignItems: "center", flexDirection: "column", margin: "15px 0" }}>
                                    <ButtonLoader
                                        text="Logout"
                                        loading={this.state.loggingOut}
                                        style={{ border: "1px solid #EE4D4D", padding: "12px 20px", width: "90%", backgroundColor: "white", color: "#EE4D4D" }}
                                        // icon={FacebookIcon}
                                        onClick={() => this.setState({ logoutDialog: true })}
                                    ></ButtonLoader>
                                    <ButtonLoader
                                        text="Delete Account"
                                        loading={this.state.deleting}
                                        style={{ backgroundColor: Colors.red, padding: "12px 20px", width: "90%", marginTop: 10 }}
                                        // icon={FacebookIcon}
                                        onClick={this.goToDelete}
                                    ></ButtonLoader>
                                </div>
                            </div>
                            : null}
                        <div style={{marginTop:10}}>
                            <span style={{ color: "#ccc" }}>Richless 2021, version 1.00</span>
                        </div>
                    </div>

                </section>
            </div>
        );
    }
}

export default withMyDataContext(Settings);